import { ChoiceList, ChoiceListItem, Radio } from '@eventbrite/marmalade';
import React from 'react';
import type { EventMode } from '../../types';

export interface EventTypeRadioButtonProps {
  eventType: EventMode | null;
  setEventType: (newEventType: EventMode) => void;
  isDisabled: boolean;
}

const EventTypeRadioButton: React.FC<EventTypeRadioButtonProps> = ({
  eventType,
  setEventType,
  isDisabled,
}) => {
  const isOnline = eventType === 'Online Event';
  const isInPerson = eventType === 'In-person Event';

  return (
    <>
      <div>
        <ChoiceList
          data-testid="event_type"
          name="Event type"
          title={
            <>
              Event type<span style={{ color: '#e25555' }}>*</span>
            </>
          }
          size="small"
          orientation="horizontal"
          selected={eventType ?? ''}
          onChange={(newSelected: EventMode, name: string, event: React.SyntheticEvent) => {
            setEventType(newSelected);
          }}
          titleHidden={false}
        >
          <ChoiceListItem value="In-person Event" label="In-person Event">
            <Radio checked={isInPerson} data-any="In-person Event" disabled={isDisabled} />
          </ChoiceListItem>
          <ChoiceListItem value="Online Event" label="Online Event">
            <Radio checked={isOnline} data-any="Online Event" disabled={isDisabled} />
          </ChoiceListItem>
        </ChoiceList>
      </div>
    </>
  );
};

export default EventTypeRadioButton;
